const path = "/ava/questionario";

const quastionarioRoutes = {
  main: `${path}`,
  cloanar: `${path}/clonar`,
};

export default quastionarioRoutes;
